import autoTable, { Styles, UserOptions } from "jspdf-autotable";
import jsPDF from "jspdf";
import { PlusJakartaSansFontBase64String } from "../../Helpers/PlusJakartaSans-base64String";
import { imgData } from "../../Helpers/smestLogoBase64ImgData";

const generateCashflowPDFBlob = async () => {
  const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });
  doc.addFileToVFS(
    "PlusJakartaSans-VariableFont_wght-normal.ttf",
    PlusJakartaSansFontBase64String
  );
  doc.addFont(
    "PlusJakartaSans-VariableFont_wght-normal.ttf",
    "PlusJakartaSans-VariableFont_wght",
    "normal"
  );
  doc.setFont("PlusJakartaSans-VariableFont_wght", "normal");
  doc.addImage(`data:image/png;base64,${imgData}`, "PNG", 153, 5, 45, 18);

  autoTable(doc, {
    html: "#redCard-heading",
    theme: "plain",
    headStyles: {
      fillColor: "#7659EE",
      textColor: "#FFFFFF",
    },
    startY: 23,
    styles: {
      font: "PlusJakartaSans-VariableFont_wght",
      fontSize: 15,
      cellWidth: "auto",
      halign: "center",
    },
  });

  const headStyles: Partial<Styles> = {
    fillColor: "#FFFFFF",
    textColor: "#7659EE",
    cellPadding: { bottom: 2, left: 2 },
    fontSize: 10,
  };

  const bodyStyles: Partial<Styles> = {
    cellPadding: { top: 0, left: 2 },
    fillColor: "#FFFFFF",
    fontStyle: "bold",
  };

  const marginRight = { right: 107 };

  const marginLeft = { left: 107 };

  const tableStyles: Partial<Styles> = {
    font: "PlusJakartaSans-VariableFont_wght",
    fontSize: 10,
    cellWidth: "auto",
    halign: "left",
  };

  const commonProps: UserOptions = {
    theme: "plain",
    headStyles,
    bodyStyles,
    showHead: "firstPage",
    styles: tableStyles,
  };

  autoTable(doc, {
    html: "#redCard-issuerName",
    ...commonProps,
    startY: 40,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-creditRating",
    ...commonProps,
    startY: 40,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-frequency",
    ...commonProps,
    startY: 60,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-faceValue",
    ...commonProps,
    startY: 60,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-coupon",
    ...commonProps,
    startY: 80,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-ytmYtc",
    ...commonProps,
    startY: 80,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-callOrMaturityDate",
    ...commonProps,
    startY: 100,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-security",
    ...commonProps,
    startY: 100,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-noOfBonds",
    ...commonProps,
    startY: 120,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-settlementDate",
    ...commonProps,
    startY: 120,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-principalAmount",
    ...commonProps,
    startY: 140,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-accruedInterest",
    ...commonProps,
    startY: 140,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-stampDuty",
    ...commonProps,
    startY: 160,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-settlementAmount",
    ...commonProps,
    startY: 160,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-price",
    ...commonProps,
    startY: 180,
    margin: marginRight,
  });

  autoTable(doc, {
    html: "#redCard-yield",
    ...commonProps,
    startY: 180,
    margin: marginLeft,
  });

  autoTable(doc, {
    html: "#redCard-cashflowTable",
    theme: "grid",
    headStyles: {
      fillColor: "#7659EE",
    },
    bodyStyles: {
      textColor: "#7659EE",
    },
    styles: {
      font: "PlusJakartaSans-VariableFont_wght",
      fontSize: 10,
      cellWidth: "auto",
      halign: "center",
    },
  });

  autoTable(doc, {
    html: "#redCard-disclaimer",
    theme: "plain",
    headStyles: {
      fillColor: "#FFFFFF",
    },
    bodyStyles: {
      textColor: "#9a9a9a",
    },
    styles: {
      font: "PlusJakartaSans-VariableFont_wght",
      fontSize: 8,
      cellWidth: "auto",
      halign: "left",
    },
  });

  const pdfBlob = doc.output("blob");

  return pdfBlob;
};

export default generateCashflowPDFBlob;
